<template>
	<div class="aup-base-video-card position-relative w-100"
		:class="{'aup-base-video-card--external': communityGalleryView }">
		<img
				class="w-100"
				:src="thumbnailUrl"
				:alt="alt"
		/>
		<IconPlay class="play_button"
				role="button"
				aria-label="Button to play video"
				:height="44"
				:width="44">

		</IconPlay>
	</div>
</template>
<script>
	import {  } from '@/api-service.js';
	import { mapState } from 'vuex';
	import { PROFILE_CONSTANTS } from '@/PROFILE_CONSTANTS';


	export default {
		name: 'BaseVideoCard',
		components: {
		},
		data() {
			return {

			};
		},
		computed: {
			thumbnailUrl: {
				get() {
					if(this.videoOptions.videoProvider == "TikTok") {
						return `https://www.tiktok.com/api/img/?itemId=${this.videoOptions.videoId}&location=0&asc=1`;
					} else {
						return this.thumbnail;
					}
				},
			},
		},
		created: async function() {

		},
		props: {
			videoUrl: {
				type: String,
				default: null,
				required: true,
			},
			videoOptions: {
				type: Object,
				default: null,
				required: true,
			},
			thumbnail: {
				type: String,
				default: '',
			}
		},
		methods: {
			handler() {},

		}
	};
</script>

<style lang="scss">
	@import '../../assets/scss/all.scss';
	.aup-base-video-card {
		max-width: 700px;
		//min-height: 200px;
		background-color: rgba(0, 0, 0, 0.4);
		cursor: pointer;
		overflow: hidden;

		img {
			display: block;
		}

		&:after {
			content: '';
			position: absolute;
			bottom: 0;
			left: 0;
			height: 100px;
			width: 100%;
			background: linear-gradient(
							to top,
							hsla(252, 100%, 2.94%, 0.6) 0%,
							hsla(252, 100%, 2.94%, 0.592) 9.6%,
							hsla(252, 100%, 2.94%, 0.571) 17.9%,
							hsla(252, 100%, 2.94%, 0.538) 25.1%,
							hsla(252, 100%, 2.94%, 0.495) 31.3%,
							hsla(252, 100%, 2.94%, 0.444) 36.8%,
							hsla(252, 100%, 2.94%, 0.389) 41.8%,
							hsla(252, 100%, 2.94%, 0.33) 46.6%,
							hsla(252, 100%, 2.94%, 0.27) 51.2%,
							hsla(252, 100%, 2.94%, 0.211) 56%,
							hsla(252, 100%, 2.94%, 0.156) 61.2%,
							hsla(252, 100%, 2.94%, 0.105) 66.9%,
							hsla(252, 100%, 2.94%, 0.062) 73.5%,
							hsla(252, 100%, 2.94%, 0.029) 81%,
							hsla(252, 100%, 2.94%, 0.008) 89.8%,
							hsla(252, 100%, 2.94%, 0) 100%
			);
			/*https://larsenwork.com/easing-gradients/#editor - gradients with easing to smooth edges*/
		}





		&__svg-badge {
			margin-right: 0.75rem;
			display: inline-flex;
			align-items: center;
		}

		&__avatar-wrapper {
			height: 4rem;
			width: 4rem;

			&--large {
				height: 6rem;
				width: 6rem;
			}
		}
		&__avatar {
			max-width: 100%;
			width: 100%;
			height: 100%;
			object-fit: cover;
			background-size: 100%;
			border: 2px solid $white;
			border-radius: 50%;
			transition: border-color 0.25s ease-in-out;
			@include animation('fade-in 1s');
		}
		&__profile-link-text {
			color: $white;
			display: inline-block;
			transition: color 0.25s ease-in-out;

			&--dark {
				color: $black;
			}
		}
		&__profile-link {
			display: flex;
			align-items: center;
			padding-right: 12px;
			box-sizing: border-box;

			&:hover {
				cursor: pointer;
				text-decoration: none;

				.aup-base-video-card__profile-link-text{
					color: $primary;
					text-decoration: underline;
				}

				.aup-base-video-card__avatar {
					border-color: $primary;
				}
			}
		}
		&__expand-icon-container {
			top: calc(50%);
			left: calc(50%);
			opacity: 0;
			transition: opacity ease-in 0.35s;
			&--gallery {
				top: 0;
				right: 0;
				left: initial;
			}
		}
		@include keyframes(fade-in) {
			0% {
				opacity: 0;
			}
			100% {
				opacity: 1;
			}
		}

		.play_button {
			position:absolute;
			z-index:100;
			top: calc(50% - 22px);
			left:calc(50% - 22px);
		}
	}
</style>
